import React, { useCallback, useEffect, useRef, useState } from 'react'

const CHARS = '!<>-_\\/[]{}—=+*^?#01'

// Text that decodes from random glyphs on mount and on hover.
function ScrambleText({ text, as: Tag = 'span', className = '' }) {
  const [out, setOut] = useState(text)
  const raf = useRef()

  const run = useCallback(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return
    cancelAnimationFrame(raf.current)
    let frame = 0
    const total = 28
    const tick = () => {
      frame++
      const reveal = Math.floor((frame / total) * text.length)
      setOut(
        text.split('').map((c, i) =>
          c === ' ' || i < reveal ? c : CHARS[Math.floor(Math.random() * CHARS.length)]
        ).join('')
      )
      if (frame < total) raf.current = requestAnimationFrame(tick)
      else setOut(text)
    }
    tick()
  }, [text])

  useEffect(() => {
    run()
    return () => cancelAnimationFrame(raf.current)
  }, [run])

  return <Tag className={className} onMouseEnter={run} aria-label={text}>{out}</Tag>
}

export default ScrambleText
